export class ContactFormResultKeys {
    static readonly FIRSTNAME = 'registration_contact_first_name';
    static readonly LASTNAME = 'registration_contact_last_name';
    static readonly EMAIL = 'registration_contact_email';
    static readonly EMAIL_CONFIRMATION = 'registration_contact_email_confirm';
    static readonly PHONE = 'registration_contact_phone';
    static readonly PHONE_EXT = 'registration_contact_phone_ext';
    static readonly SPECIALIST_GROUP = 'registration_specialist_group_select';
    static readonly ORGANIZATION_TYPE = 'registration_organization_type_select';
    static readonly PRACTICE = 'registration_contact_practice';
    static readonly PROVINCE = 'registration_contact_provinces';
    static readonly PRACTICE_DEFAULT = 'registration_contact_practice_default';
}

export interface IContactFormResultModel {
    registration_contact_first_name: string;
    registration_contact_last_name: string;
    registration_contact_email: string;
    registration_contact_email_confirm: string;
    registration_contact_phone: string;
    registration_contact_phone_ext: string;
    registration_specialist_group_select: number;
    registration_organization_type_select: number;
    registration_contact_practice: string;
    registration_contact_provinces: string;
    registration_contact_practice_default: string;
}
